import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SLICE_NAME } from './constants';
import { Space, SpacesContainerState } from './spaces';

const initialState: SpacesContainerState = {
  listSpaces: [],
  page: 0,
  pageSize: 20,
  total: 0,
  isFetching: false,
  search: '',
  showSpaceDetails: false,
};

export const spacesSlice = createSlice({
  name: SLICE_NAME,

  initialState,

  reducers: {
    setListSpaces: (state, action: PayloadAction<Space[]>) => {
      state.listSpaces = action.payload;
    },
    addSpaces: (state, action: PayloadAction<Space[]>) => {
      state.listSpaces = state.listSpaces.concat(action.payload);
    },
    deleteSpaces: (state, action: PayloadAction<string>) => {
      state.listSpaces = state.listSpaces.filter(
        (s) => s.id !== action.payload,
      );
      state.total = state.total - 1;
    },
    updateSpaceById: (
      state,
      action: PayloadAction<Partial<Space> & { id: string }>,
    ) => {
      const index = state.listSpaces.findIndex(
        (s) => s.id === action.payload.id,
      );
      if (index !== -1) {
        const sp = state.listSpaces[index];
        Object.assign(sp, action.payload);
        state.listSpaces[index] = sp;
      }
    },
    setPage: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
    },
    setActiveSpace: (state, action: PayloadAction<Space | undefined>) => {
      state.activeSpace = action.payload;
    },
    setSearch: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
    },
    setTotal: (state, action: PayloadAction<number>) => {
      state.total = action.payload;
    },
    setIsFetching: (state, action: PayloadAction<boolean>) => {
      state.isFetching = action.payload;
    },
    setShowSpaceDetails: (state, action: PayloadAction<boolean>) => {
      state.showSpaceDetails = action.payload;
    },
  },
});

export const {
  setListSpaces,
  addSpaces,
  setPage,
  setActiveSpace,
  setSearch,
  setTotal,
  setIsFetching,
  updateSpaceById,
  setShowSpaceDetails,
  deleteSpaces,
} = spacesSlice.actions;

export default spacesSlice.reducer;
